import React from 'react';

import { ButtonWithIcon } from '@/components/global/ButtonWithIcon';
import { Hyperlink } from '@/components/global/Hyperlink';

import { TOnboardingStep } from '@/services/requests/Recommendation/types/template4';

import { getImage } from '@/helpers/ImageHelper';

type TProps = {
  data: TOnboardingStep;
  isShow: boolean;
  isLastScreen: boolean;
  onNext: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onSkip?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onSubmit?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export function Screen({
  data: { title, description, next_step, last_step, image },
  onNext,
  onSkip,
  onSubmit,
  isShow,
  isLastScreen,
}: TProps) {
  const formattedClass = `vitrine-template4__screen-content ${
    isShow ? 'vitrine-template4__screen--hide' : ''
  }`;

  const formattedImage = getImage(image, 'web')?.image.url || '';
  return (
    <div className={formattedClass}>
      <div className="vitrine-template4__box1">
        <h2
          className="vitrine-template4__header"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {description && (
          <p className="vitrine-template4__description">{description}</p>
        )}

        <div className="vitrine-template4__actions">
          {!isLastScreen ? (
            <>
              <ButtonWithIcon
                className="vitrine-template4__button"
                text={next_step}
                position="right"
                icon={{ name: 'arrow_forward_ios', size: 'small' }}
                onClick={onNext}
              />
              {last_step && (
                <Hyperlink
                  className="vitrine-template4__link"
                  text={last_step}
                  href="https://smiles.com.br"
                  onClick={onSkip}
                />
              )}
            </>
          ) : (
            <ButtonWithIcon
              className="vitrine-template4__button"
              text={next_step}
              position="right"
              icon={{ name: 'arrow_forward_ios', size: 'small' }}
              onClick={onSubmit}
            />
          )}
        </div>
      </div>
      <div className="vitrine-template4__box2">
        <img
          className="vitrine-template4__image"
          src={formattedImage}
          data-testid="image"
          alt="Optin"
        />
      </div>
    </div>
  );
}
